var babelHelpers={};babelHelpers.typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol?"symbol":typeof a},babelHelpers.jsx=function(){var a="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103;return function(c,d,e,f){var g=c&&c.defaultProps,h=arguments.length-3;if(d||0===h||(d={}),d&&g)for(var i in g)void 0===d[i]&&(d[i]=g[i]);else d||(d=g||{});if(1===h)d.children=f;else if(h>1){for(var j=Array(h),k=0;k<h;k++)j[k]=arguments[k+3];d.children=j}return{$$typeof:a,type:c,key:void 0===e?null:""+e,ref:null,props:d,_owner:null}}}(),babelHelpers.asyncToGenerator=function(a){return function(){var b=a.apply(this,arguments);return new Promise(function(a,c){function d(e,f){try{var g=b[e](f),h=g.value}catch(a){return void c(a)}return g.done?void a(h):Promise.resolve(h).then(function(a){return d("next",a)},function(a){return d("throw",a)})}return d("next")})}},babelHelpers.classCallCheck=function(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")},babelHelpers.createClass=function(){function a(a,b){for(var c=0;c<b.length;c++){var d=b[c];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(a,d.key,d)}}return function(b,c,d){return c&&a(b.prototype,c),d&&a(b,d),b}}(),babelHelpers.defineEnumerableProperties=function(a,b){for(var c in b){var d=b[c];d.configurable=d.enumerable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(a,c,d)}return a},babelHelpers.defaults=function(a,b){for(var c=Object.getOwnPropertyNames(b),d=0;d<c.length;d++){var e=c[d],f=Object.getOwnPropertyDescriptor(b,e);f&&f.configurable&&void 0===a[e]&&Object.defineProperty(a,e,f)}return a},babelHelpers.defineProperty=function(a,b,c){return b in a?Object.defineProperty(a,b,{value:c,enumerable:!0,configurable:!0,writable:!0}):a[b]=c,a},babelHelpers.extends=Object.assign||function(a){for(var b=1;b<arguments.length;b++){var c=arguments[b];for(var d in c)Object.prototype.hasOwnProperty.call(c,d)&&(a[d]=c[d])}return a},babelHelpers.get=function a(b,c,d){null===b&&(b=Function.prototype);var e=Object.getOwnPropertyDescriptor(b,c);if(void 0===e){var f=Object.getPrototypeOf(b);return null===f?void 0:a(f,c,d)}if("value"in e)return e.value;var g=e.get;if(void 0!==g)return g.call(d)},babelHelpers.inherits=function(a,b){if("function"!=typeof b&&null!==b)throw new TypeError("Super expression must either be null or a function, not "+typeof b);a.prototype=Object.create(b&&b.prototype,{constructor:{value:a,enumerable:!1,writable:!0,configurable:!0}}),b&&(Object.setPrototypeOf?Object.setPrototypeOf(a,b):a.__proto__=b)},babelHelpers.instanceof=function(a,b){return null!=b&&"undefined"!=typeof Symbol&&b[Symbol.hasInstance]?b[Symbol.hasInstance](a):a instanceof b},babelHelpers.interopRequireDefault=function(a){return a&&a.__esModule?a:{default:a}},babelHelpers.interopRequireWildcard=function(a){if(a&&a.__esModule)return a;var b={};if(null!=a)for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&(b[c]=a[c]);return b.default=a,b},babelHelpers.newArrowCheck=function(a,b){if(a!==b)throw new TypeError("Cannot instantiate an arrow function")},babelHelpers.objectDestructuringEmpty=function(a){if(null==a)throw new TypeError("Cannot destructure undefined")},babelHelpers.objectWithoutProperties=function(a,b){var c={};for(var d in a)b.indexOf(d)>=0||Object.prototype.hasOwnProperty.call(a,d)&&(c[d]=a[d]);return c},babelHelpers.possibleConstructorReturn=function(a,b){if(!a)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!b||"object"!=typeof b&&"function"!=typeof b?a:b},babelHelpers.selfGlobal="undefined"==typeof global?self:global,babelHelpers.set=function a(b,c,d,e){var f=Object.getOwnPropertyDescriptor(b,c);if(void 0===f){var g=Object.getPrototypeOf(b);null!==g&&a(g,c,d,e)}else if("value"in f&&f.writable)f.value=d;else{var h=f.set;void 0!==h&&h.call(e,d)}return d},babelHelpers.slicedToArray=function(){function a(a,b){var c=[],d=!0,e=!1,f=void 0;try{for(var h,g=a[Symbol.iterator]();!(d=(h=g.next()).done)&&(c.push(h.value),!b||c.length!==b);d=!0);}catch(a){e=!0,f=a}finally{try{!d&&g.return&&g.return()}finally{if(e)throw f}}return c}return function(b,c){if(Array.isArray(b))return b;if(Symbol.iterator in Object(b))return a(b,c);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),babelHelpers.slicedToArrayLoose=function(a,b){if(Array.isArray(a))return a;if(Symbol.iterator in Object(a)){for(var e,c=[],d=a[Symbol.iterator]();!(e=d.next()).done&&(c.push(e.value),!b||c.length!==b););return c}throw new TypeError("Invalid attempt to destructure non-iterable instance")},babelHelpers.taggedTemplateLiteral=function(a,b){return Object.freeze(Object.defineProperties(a,{raw:{value:Object.freeze(b)}}))},babelHelpers.taggedTemplateLiteralLoose=function(a,b){return a.raw=b,a},babelHelpers.temporalRef=function(a,b,c){if(a===c)throw new ReferenceError(b+" is not defined - temporal dead zone");return a},babelHelpers.temporalUndefined={},babelHelpers.toArray=function(a){return Array.isArray(a)?a:Array.from(a)},babelHelpers.toConsumableArray=function(a){if(Array.isArray(a)){for(var b=0,c=Array(a.length);b<a.length;b++)c[b]=a[b];return c}return Array.from(a)};

var BunnyElement = {
	getCurrentDocumentPosition: function getCurrentDocumentPosition() {
		var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
		
		//return Math.abs(document.body.getBoundingClientRect().y);
		return top ? window.scrollY : window.scrollY + window.innerHeight;
	},
	getPosition: function getPosition(el) {
		var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
		
		var curTop = 0;
		var originalEl = el;
		if (el.offsetParent) {
			do {
				curTop += el.offsetTop;
			} while (el = el.offsetParent);
		}
		if (!top) {
			curTop += originalEl.offsetHeight;
		}
		return curTop;
	},
	isInViewport: function isInViewport(el) {
		var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
		var top = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
		
		var docPos = this.getCurrentDocumentPosition(top);
		var elPos = this.getPosition(el, top);
		return elPos + offset <= docPos;
	},
	scrollToIfNeeded: function scrollToIfNeeded(target) {
		var viewportOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
		var viewportTop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
		var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
		var scrollOffset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
		
		if (!this.isInViewport(target, viewportOffset, viewportTop)) {
			this.scrollTo(target, duration, scrollOffset);
		}
	},
	
	
	/**
	* Smooth scrolling to DOM element or to relative window position
	* If target is string it should be CSS selector
	* If target is object it should be DOM element
	* If target is number - it is used to relatively scroll X pixels form current position
	*
	* Based on https://www.sitepoint.com/smooth-scrolling-vanilla-javascript/
	*
	* @param {HTMLElement, string, number} target
	* @param {Number|function} duration
	* @param {Number} offset
	* @param {HTMLElement} rootElement
	*/
	scrollTo: function scrollTo(target) {
		var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
		var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
		var rootElement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window;
		
		return new Promise(function (onAnimationEnd) {
			
			var element = void 0;
			if (typeof target === 'string') {
				element = document.querySelector(target);
			} else if ((typeof target === 'undefined' ? 'undefined' : babelHelpers.typeof(target)) === 'object') {
				element = target;
			} else {
				// number
				element = null;
			}
			
			if (element !== null && element.offsetParent === null) {
				// element is not visible, scroll to top of parent element
				element = element.parentNode;
			}
			
			var start = rootElement === window ? window.pageYOffset : rootElement.scrollTop;
			var distance = 0;
			if (element !== null) {
				distance = element.getBoundingClientRect().top;
			} else {
				// number
				distance = target;
			}
			
			distance = distance + offset;
			
			if (typeof duration === 'function') {
				duration = duration(distance);
			}
			
			var timeStart = 0;
			var timeElapsed = 0;
			
			requestAnimationFrame(function (time) {
				timeStart = time;
				loop(time);
			});
			
			function setScrollYPosition(el, y) {
				if (el === window) {
					window.scrollTo(0, y);
				} else {
					el.scrollTop = y;
				}
			}
			
			function loop(time) {
				timeElapsed = time - timeStart;
				setScrollYPosition(rootElement, easeInOutQuad(timeElapsed, start, distance, duration));
				if (timeElapsed < duration) {
					requestAnimationFrame(loop);
				} else {
					end();
				}
			}
			
			function end() {
				setScrollYPosition(rootElement, start + distance);
				onAnimationEnd();
			}
			
			// Robert Penner's easeInOutQuad - http://robertpenner.com/easing/
			function easeInOutQuad(t, b, c, d) {
				t /= d / 2;
				if (t < 1) return c / 2 * t * t + b;
				t--;
				return -c / 2 * (t * (t - 2) - 1) + b;
			}
		});
	},
	hide: function hide(element) {
		return new Promise(function (resolve) {
			element.style.opacity = 0;
			element.style.overflow = 'hidden';
			var steps = 40;
			var step_delay_ms = 10;
			var height = element.offsetHeight;
			var height_per_step = Math.round(height / steps);
			element._originalHeight = height;
			
			var _loop = function _loop(k) {
				if (k === steps) {
					setTimeout(function () {
						element.style.display = 'none';
						element.style.height = '0px';
						resolve();
					}, step_delay_ms * k);
				} else {
					setTimeout(function () {
						element.style.height = height_per_step * (steps - k) + 'px';
					}, step_delay_ms * k);
				}
			};
			
			for (var k = 1; k <= steps; k++) {
				_loop(k);
			}
		});
	},
	show: function show(element) {
		if (element._originalHeight === undefined) {
			throw new Error('element._originalHeight is undefined. Save original height when hiding element or use BunnyElement.hide()');
		}
		return new Promise(function (resolve) {
			element.style.display = '';
			var steps = 40;
			var step_delay_ms = 10;
			var height = element._originalHeight;
			var height_per_step = Math.round(height / steps);
			delete element._originalHeight;
			
			var _loop2 = function _loop2(k) {
				if (k === steps) {
					setTimeout(function () {
						element.style.opacity = 1;
						element.style.height = '';
						element.style.overflow = '';
						resolve();
					}, step_delay_ms * k);
				} else {
					setTimeout(function () {
						element.style.height = height_per_step * k + 'px';
					}, step_delay_ms * k);
				}
			};
			
			for (var k = 1; k <= steps; k++) {
				_loop2(k);
			}
		});
	},
	remove: function remove(element) {
		element.parentNode.removeChild(element);
	}
};

(function () {

	if ( typeof window.CustomEvent === "function" ) return false;
  
	function CustomEvent ( event, params ) {
	  params = params || { bubbles: false, cancelable: false, detail: undefined };
	  var evt = document.createEvent( 'CustomEvent' );
	  evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
	  return evt;
	 }
  
	CustomEvent.prototype = window.Event.prototype;
  
	window.CustomEvent = CustomEvent;
})();
  
  
var ValidationConfig = {

	// div/node class name selector which contains one label, one input, one help text etc.
	classInputGroup: 'form-group',
	// class to be applied on input group node if it has invalid input
	classInputGroupError: 'has-danger',
	// class to be applied on input group node if it input passed validation (is valid)
	classInputGroupSuccess: 'has-success',

	// label to pick textContent from to insert field name into error message
	classLabel: 'form-control-label',

	// error message tag name
	tagNameError: 'small',
	// error message class
	classError: 'text-help',

	// query selector to search inputs within input groups to validate
	selectorInput: '[name]'

};

/**
 * Bunny Form Validation default Translations (EN)
 *
 * object key = validator method name
 * may use additional parameters in rejected (invalid) Promise
 * each invalid input will receive {label} parameter anyway
 * ajax error message should be received from server via JSON response in "message" key
 */
var ValidationLang = {

	required: "'{label}' is required",
	email: "'{label}' should be a valid e-mail address",
	url: "{label} should be a valid website URL",
	tel: "'{label}' is not a valid telephone number",
	maxLength: "'{label}' length must be < '{maxLength}'",
	minLength: "'{label}' length must be > '{minLength}'",
	maxFileSize: "Max file size must be < {maxFileSize}MB, uploaded {fileSize}MB",
	image: "'{label}' should be an image (JPG or PNG)",
	minImageDimensions: "'{label}' must be > {minWidth}x{minHeight}, uploaded {width}x{height}",
	maxImageDimensions: "'{label}' must be < {maxWidth}x{maxHeight}, uploaded {width}x{height}",
	requiredFromList: "Select '{label}' from list",
	confirmation: "'{label}' is not equal to '{originalLabel}'",
	minOptions: "Please select at least {minOptionsCount} options"

};

/**
 * Bunny Validation helper - get file to validate
 * @param {HTMLInputElement} input
 * @returns {File|Blob|boolean} - If no file uploaded - returns false
 * @private
 */
var _bn_getFile = function _bn_getFile(input) {
	// if there is custom file upload logic, for example, images are resized client-side
	// generated Blobs should be assigned to fileInput._file
	// and can be sent via ajax with FormData

	// if file was deleted, custom field can be set to an empty string

	// Bunny Validation detects if there is custom Blob assigned to file input
	// and uses this file for validation instead of original read-only input.files[]
	if (input._file !== undefined && input._file !== '') {
		if (input._file instanceof Blob === false) {
			console.error("Custom file for input " + input.name + " is not an instance of Blob");
			return false;
		}
		return input._file;
	}
	return input.files[0] || false;
};

/**
 * Bunny Form Validation Validators
 *
 * Each validator is a separate method
 * Each validator return Promise
 * Each Promise has valid and invalid callbacks
 * Invalid callback may contain argument - string of error message or object of additional params for lang error message
 */
var ValidationValidators = {
	required: function required(input) {
		return new Promise(function (valid, invalid) {
			if (input.hasAttribute('required')) {
				// input is required, check value
				if (input.getAttribute('type') !== 'file' && input.value === '' || (input.type === 'radio' || input.type === 'checkbox') && input.validity.valueMissing || input.getAttribute('type') === 'file' && _bn_getFile(input) === false) {
					// input is empty or file is not uploaded
					invalid();
				} else {
					valid();
				}
			} else {
				valid();
			}
		});
	},
	email: function email(input) {
		return new Promise(function (valid, invalid) {
			if (input.value.length > 0 && input.getAttribute('type') === 'email') {
				// input is email, parse string to match email regexp
				var Regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
				if (Regex.test(input.value)) {
					valid();
				} else {
					invalid();
				}
			} else {
				valid();
			}
		});
	},
	url: function url(input) {
		return new Promise(function (valid, invalid) {
			if (input.value.length > 0 && input.getAttribute('type') === 'url') {
				// input is URL, parse string to match website URL regexp
				var Regex = /(^|\s)((https?:\/\/)?[\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?)/gi;
				if (Regex.test(input.value)) {
					valid();
				} else {
					invalid();
				}
			} else {
				valid();
			}
		});
	},
	tel: function tel(input) {
		return new Promise(function (valid, invalid) {
			if (input.value.length > 0 && input.getAttribute('type') === 'tel') {
				// input is tel, parse string to match tel regexp
				var Regex = /^[0-9\-\+\(\)\#\ \*]{6,20}$/;
				if (Regex.test(input.value)) {
					valid();
				} else {
					invalid();
				}
			} else {
				valid();
			}
		});
	},
	maxLength: function maxLength(input) {
		return new Promise(function (valid, invalid) {
			if (input.getAttribute('maxlength') !== null && input.value.length > input.getAttribute('maxlength')) {
				invalid({ maxLength: input.getAttribute('maxlength') });
			} else {
				valid();
			}
		});
	},
	minLength: function minLength(input) {
		return new Promise(function (valid, invalid) {
			if (input.getAttribute('minlength') !== null && input.value.length < input.getAttribute('minlength')) {
				invalid({ minLength: input.getAttribute('minlength') });
			} else {
				valid();
			}
		});
	},
	maxFileSize: function maxFileSize(input) {
		return new Promise(function (valid, invalid) {
			if (input.getAttribute('type') === 'file' && input.hasAttribute('maxfilesize') && _bn_getFile(input) !== false) {
				var maxFileSize = parseFloat(input.getAttribute('maxfilesize')); // in MB
				var fileSize = (_bn_getFile(input).size / 1000000).toFixed(2); // in MB
				if (fileSize <= maxFileSize) {
					valid(input);
				} else {
					invalid({ maxFileSize: maxFileSize, fileSize: fileSize });
				}
			} else {
				valid(input);
			}
		});
	},


	// if file input has "accept" attribute and it contains "image",
	// then check if uploaded file is a JPG or PNG
	image: function image(input) {
		return new Promise(function (valid, invalid) {
			if (input.getAttribute('type') === 'file' && input.getAttribute('accept').indexOf('image') > -1 && _bn_getFile(input) !== false) {
				BunnyFile.getSignature(_bn_getFile(input)).then(function (signature) {
					if (BunnyFile.isJpeg(signature) || BunnyFile.isPng(signature)) {
						valid();
					} else {
						invalid({ signature: signature });
					}
				}).catch(function (e) {
					invalid(e);
				});
			} else {
				valid();
			}
		});
	},
	minImageDimensions: function minImageDimensions(input) {
		return new Promise(function (valid, invalid) {
			if (input.hasAttribute('mindimensions') && _bn_getFile(input) !== false) {
				var _input$getAttribute$s = input.getAttribute('mindimensions').split('x'),
					_input$getAttribute$s2 = babelHelpers.slicedToArray(_input$getAttribute$s, 2),
					minWidth = _input$getAttribute$s2[0],
					minHeight = _input$getAttribute$s2[1];

				BunnyImage.getImageByBlob(_bn_getFile(input)).then(function (img) {
					var width = BunnyImage.getImageWidth(img);
					var height = BunnyImage.getImageHeight(img);
					if (width < minWidth || height < minHeight) {
						invalid({ width: width, height: height, minWidth: minWidth, minHeight: minHeight });
					} else {
						valid();
					}
				}).catch(function (e) {
					invalid(e);
				});
			} else {
				valid();
			}
		});
	},
	maxImageDimensions: function maxImageDimensions(input) {
		return new Promise(function (valid, invalid) {
			if (input.hasAttribute('maxdimensions') && _bn_getFile(input) !== false) {
				var _input$getAttribute$s3 = input.getAttribute('maxdimensions').split('x'),
					_input$getAttribute$s4 = babelHelpers.slicedToArray(_input$getAttribute$s3, 2),
					maxWidth = _input$getAttribute$s4[0],
					maxHeight = _input$getAttribute$s4[1];

				BunnyImage.getImageByBlob(_bn_getFile(input)).then(function (img) {
					var width = BunnyImage.getImageWidth(img);
					var height = BunnyImage.getImageHeight(img);
					if (width > maxWidth || height > maxHeight) {
						invalid({ width: width, height: height, maxWidth: maxWidth, maxHeight: maxHeight });
					} else {
						valid();
					}
				}).catch(function (e) {
					invalid(e);
				});
			} else {
				valid();
			}
		});
	},
	requiredFromList: function requiredFromList(input) {
		return new Promise(function (valid, invalid) {
			var id = void 0;
			if (input.hasAttribute('requiredfromlist')) {
				id = input.getAttribute('requiredfromlist');
			} else {
				id = input.name + '_id';
			}
			var srcInput = document.getElementById(id);
			if (srcInput) {
				if (srcInput.value.length > 0) {
					valid();
				} else {
					invalid();
				}
			} else {
				valid();
			}
		});
	},
	minOptions: function minOptions(input) {
		return new Promise(function (valid, invalid) {
			if (input.hasAttribute('minoptions')) {
				var minOptionsCount = parseInt(input.getAttribute('minoptions'));
				var inputGroup = ValidationUI.getInputGroup(input);
				var hiddenInputs = inputGroup.getElementsByTagName('input');
				var selectedOptionsCount = 0;
				[].forEach.call(hiddenInputs, function (hiddenInput) {
					if (hiddenInput !== input && hiddenInput.value !== '') {
						selectedOptionsCount++;
					}
				});
				if (selectedOptionsCount < minOptionsCount) {
					invalid({ minOptionsCount: minOptionsCount });
				} else {
					valid();
				}
			} else {
				valid();
			}
		});
	},
	confirmation: function confirmation(input) {
		return new Promise(function (valid, invalid) {
			if (input.name.indexOf('_confirmation') > -1) {
				var originalInputId = input.name.substr(0, input.name.length - 13);
				var originalInput = document.getElementById(originalInputId);
				if (originalInput.value == input.value) {
					valid();
				} else {
					invalid({ originalLabel: ValidationUI.getLabel(ValidationUI.getInputGroup(originalInput)).textContent });
				}
			} else {
				valid();
			}
		});
	},


	// if input's value is not empty and input has attribute "data-ajax" which should contain ajax URL with {value}
	// which will be replaced by URI encoded input.value
	// then ajax request will be made to validate input
	//
	// ajax request should return JSON response
	// if JSON response has "message" key and message key is not empty string - input is invalid
	// server should return validation error message, it may contain {label}
	// Does not works with file inputs
	ajax: function ajax(input) {
		return new Promise(function (valid, invalid) {
			if (input.dataset.ajax !== undefined && input.value.length > 0) {
				var url = input.dataset.ajax.replace('{value}', encodeURIComponent(input.value));
				Ajax.get(url, function (data) {
					data = JSON.parse(data);
					if (data.message !== undefined && data.message !== '') {
						invalid(data.message);
					} else {
						valid();
					}
				}, function () {
					invalid('Ajax error');
				});
			} else {
				valid();
			}
		});
	}
};

/**
 * @package BunnyJS
 * @component Validation
 *
 * Base Object to work with DOM, creates error messages
 * and searches for inputs within "input groups" and related elements
 * Each input should be wrapped around an "input group" element
 * Each "input group" should contain one input, may contain one label
 * Multiple inputs within same "Input group" should not be used for validation
 * <fieldset> is recommended to be used to wrap more then one input
 */
var ValidationUI = {

	config: ValidationConfig,

	/* ************************************************************************
	 * ERROR MESSAGE
	 */

	/**
	 * DOM algorithm - where to insert error node/message
	 *
	 * @param {HTMLElement} inputGroup
	 * @param {HTMLElement} errorNode
	 */
	insertErrorNode: function insertErrorNode(inputGroup, errorNode) {
		inputGroup.appendChild(errorNode);
	},


	/**
	 * DOM algorithm - where to add/remove error class
	 *
	 * @param {HTMLElement} inputGroup
	 */
	toggleErrorClass: function toggleErrorClass(inputGroup) {
		inputGroup.classList.toggle(this.config.classInputGroupError);
	},


	/**
	 * Create DOM element for error message
	 *
	 * @returns {HTMLElement}
	 */
	createErrorNode: function createErrorNode() {
		var el = document.createElement(this.config.tagNameError);
		el.classList.add(this.config.classError);
		return el;
	},


	/**
	 * Find error message node within input group or false if not found
	 *
	 * @param {HTMLElement} inputGroup
	 *
	 * @returns {HTMLElement|boolean}
	 */
	getErrorNode: function getErrorNode(inputGroup) {
		return inputGroup.getElementsByClassName(this.config.classError)[0] || false;
	},


	/**
	 * Removes error node and class from input group if exists
	 *
	 * @param {HTMLElement} inputGroup
	 */
	removeErrorNode: function removeErrorNode(inputGroup) {
		var el = this.getErrorNode(inputGroup);
		if (el) {
			el.parentNode.removeChild(el);
			this.toggleErrorClass(inputGroup);
		}
	},


	/**
	 * Removes all error node and class from input group if exists within section
	 *
	 * @param {HTMLElement} section
	 */
	removeErrorNodesFromSection: function removeErrorNodesFromSection(section) {
		var _this = this;

		[].forEach.call(this.getInputGroupsInSection(section), function (inputGroup) {
			_this.removeErrorNode(inputGroup);
		});
	},


	/**
	 * Creates and includes into DOM error node or updates error message
	 *
	 * @param {HTMLElement} inputGroup
	 * @param {String} message
	 */
	setErrorMessage: function setErrorMessage(inputGroup, message) {
		var errorNode = this.getErrorNode(inputGroup);
		if (errorNode === false) {
			// container for error message doesn't exists, create new
			errorNode = this.createErrorNode();
			this.toggleErrorClass(inputGroup);
			this.insertErrorNode(inputGroup, errorNode);
		}
		// set or update error message
		errorNode.textContent = message;
	},


	/**
	 * Marks input as valid
	 *
	 * @param {HTMLElement} inputGroup
	 */
	setInputValid: function setInputValid(inputGroup) {
		inputGroup.classList.add(this.config.classInputGroupSuccess);
	},


	/* ************************************************************************
	 * SEARCH DOM
	 */

	/**
	 * DOM Algorithm - which inputs should be selected for validation
	 *
	 * @param {HTMLElement} inputGroup
	 *
	 * @returns {HTMLElement|boolean}
	 */
	getInput: function getInput(inputGroup) {
		return inputGroup.querySelector(this.config.selectorInput) || false;
	},


	/**
	 * Find closest parent inputGroup element by Input element
	 *
	 * @param {HTMLElement} input
	 *
	 * @returns {HTMLElement}
	 */
	getInputGroup: function getInputGroup(input) {
		var el = input;
		while ((el = el.parentNode) && !el.classList.contains(this.config.classInputGroup)) {}
		return el;
	},


	/**
	 * Find inputs in section
	 *
	 * @meta if second argument true - return object with meta information to use during promise resolving
	 *
	 * @param {HTMLElement} node
	 * @param {boolean} resolving = false
	 *
	 * @returns {Array|Object}
	 */
	getInputsInSection: function getInputsInSection(node) {
		var resolving = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

		var inputGroups = this.getInputGroupsInSection(node);
		var inputs = void 0;
		if (resolving) {
			inputs = {
				inputs: {},
				invalidInputs: {},
				length: 0,
				unresolvedLength: 0,
				invalidLength: 0
			};
		} else {
			inputs = [];
		}
		for (var k = 0; k < inputGroups.length; k++) {
			var input = this.getInput(inputGroups[k]);
			if (input === false) {
				console.error(inputGroups[k]);
				throw new Error('Bunny Validation: Input group has no input');
			}
			if (resolving) {
				inputs.inputs[k] = {
					input: input,
					isValid: null
				};
				inputs.length++;
				inputs.unresolvedLength++;
			} else {
				inputs.push(input);
			}
		}
		return inputs;
	},


	/**
	 * Find label associated with input within input group
	 *
	 * @param {HTMLElement} inputGroup
	 *
	 * @returns {HTMLElement|boolean}
	 */
	getLabel: function getLabel(inputGroup) {
		return inputGroup.getElementsByTagName('label')[0] || false;
	},


	/**
	 * Find all input groups within section
	 *
	 * @param {HTMLElement} node
	 *
	 * @returns {HTMLCollection}
	 */
	getInputGroupsInSection: function getInputGroupsInSection(node) {
		return node.getElementsByClassName(this.config.classInputGroup);
	}
};

var Validation = {

	validators: ValidationValidators,
	lang: ValidationLang,
	ui: ValidationUI,

	init: function init(form) {
		var _this2 = this;

		var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

		// disable browser built-in validation
		form.setAttribute('novalidate', '');

		
		if (inline) {
			this.initInline(form);
		}else{
			
			form.addEventListener('submit', function (e) {
				e.preventDefault();
				var submitBtns = form.querySelectorAll('[type="submit"]');
				[].forEach.call(submitBtns, function (submitBtn) {
					submitBtn.disabled = true;
				});
				_this2.validateSection(form).then(function (result) {
					[].forEach.call(submitBtns, function (submitBtn) {
						submitBtn.disabled = false;
					});
					if (result === true) {
						form.submit();
					} else {
						_this2.focusInput(result[0]);
					}
				});
			});
		}
	},
	initInline: function initInline(node) {
		var _this3 = this;

		var inputs = this.ui.getInputsInSection(node);
		inputs.forEach(function (input) {
			input.addEventListener('change', function () {
				_this3.checkInput(input).catch(function (e) {});
			});
		});
	},
	validateForm: function validateForm(form) {
		var _flag  = null;
		var _this2 = this;

		var submitBtns = form.querySelectorAll('[type="submit"]');
		[].forEach.call(submitBtns, function (submitBtn) {
			submitBtn.disabled = true;
		});
		
		_this2.validateSection(form).then(function (result) {

			[].forEach.call(submitBtns, function (submitBtn) {
				submitBtn.disabled = false;
			});
		
			if (result === true) {
				_flag = true;
			} else {
				_flag = false;
			}

			var event = new CustomEvent('validation', { 'detail': {'status':_flag} });

			form.dispatchEvent(event);
		});
	},
	validateSection: function validateSection(node) {
		var _this4 = this;

		if (node.__bunny_validation_state === undefined) {
			node.__bunny_validation_state = true;
		} else {
			throw new Error('Bunny Validation: validation already in progress.');
		}
		return new Promise(function (resolve) {
			var resolvingInputs = _this4.ui.getInputsInSection(node, true);
			if (resolvingInputs.length === 0) {
				// nothing to validate, end
				_this4._endSectionValidation(node, resolvingInputs, resolve);
			} else {
				// run async validation for each input
				// when last async validation will be completed, call validSection or invalidSection
				var promises = [];

				var _loop = function _loop(i) {
					var input = resolvingInputs.inputs[i].input;

					_this4.checkInput(input).then(function () {
						_this4._addValidInput(resolvingInputs, input);
						if (resolvingInputs.unresolvedLength === 0) {
							_this4._endSectionValidation(node, resolvingInputs, resolve);
						}
					}).catch(function (errorMessage) {
						_this4._addInvalidInput(resolvingInputs, input);
						if (resolvingInputs.unresolvedLength === 0) {
							_this4._endSectionValidation(node, resolvingInputs, resolve);
						}
					});
				};

				for (var i = 0; i < resolvingInputs.length; i++) {
					_loop(i);
				}

				// if there are not resolved promises after 3s, terminate validation, mark pending inputs as invalid
				setTimeout(function () {
					if (resolvingInputs.unresolvedLength > 0) {
						var unresolvedInputs = _this4._getUnresolvedInputs(resolvingInputs);
						for (var i = 0; i < unresolvedInputs.length; i++) {
							var _input = unresolvedInputs[i];
							var inputGroup = _this4.ui.getInputGroup(_input);
							_this4._addInvalidInput(resolvingInputs, _input);
							_this4.ui.setErrorMessage(inputGroup, 'Validation terminated after 3s');
							if (resolvingInputs.unresolvedLength === 0) {
								_this4._endSectionValidation(node, resolvingInputs, resolve);
							}
						}
					}
				}, 3000);
			}
		});
	},
	focusInput: function focusInput(input) {
		var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
		var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -50;

		BunnyElement.scrollTo(input, delay, offset);
		input.focus();
		if (input.offsetParent !== null && input.setSelectionRange !== undefined && ['text', 'search', 'url', 'tel', 'password'].indexOf(input.type) !== -1 && typeof input.setSelectionRange === 'function') {
			input.setSelectionRange(input.value.length, input.value.length);
		}
	},
	checkInput: function checkInput(input) {
		var _this5 = this;

		return new Promise(function (valid, invalid) {
			_this5._checkInput(input, 0, valid, invalid);
		});
	},
	_addValidInput: function _addValidInput(resolvingInputs, input) {
		resolvingInputs.unresolvedLength--;
		for (var k in resolvingInputs.inputs) {
			if (input === resolvingInputs.inputs[k].input) {
				resolvingInputs.inputs[k].isValid = true;
				break;
			}
		}
	},
	_addInvalidInput: function _addInvalidInput(resolvingInputs, input) {
		resolvingInputs.unresolvedLength--;
		resolvingInputs.invalidLength++;
		for (var k in resolvingInputs.inputs) {
			if (input === resolvingInputs.inputs[k].input) {
				resolvingInputs.inputs[k].isValid = false;
				resolvingInputs.invalidInputs[k] = input;
				break;
			}
		}
	},
	_getUnresolvedInputs: function _getUnresolvedInputs(resolvingInputs) {
		var unresolvedInputs = [];
		for (var k in resolvingInputs.inputs) {
			if (!resolvingInputs.inputs[k].isValid) {
				unresolvedInputs.push(resolvingInputs.inputs[k].input);
			}
		}
		return unresolvedInputs;
	},
	_endSectionValidation: function _endSectionValidation(node, resolvingInputs, resolve) {
		delete node.__bunny_validation_state;

		if (resolvingInputs.invalidLength === 0) {
			// form or section is valid
			return resolve(true);
		} else {
			var invalidInputs = [];
			for (var k in resolvingInputs.invalidInputs) {
				invalidInputs.push(resolvingInputs.invalidInputs[k]);
			}
			// form or section has invalid inputs
			return resolve(invalidInputs);
		}
	},
	_checkInput: function _checkInput(input, index, valid, invalid) {
		var _this6 = this;

		var validators = Object.keys(this.validators);
		var currentValidatorName = validators[index];
		var currentValidator = this.validators[currentValidatorName];
		currentValidator(input).then(function () {
			index++;
			if (validators[index] !== undefined) {
				_this6._checkInput(input, index, valid, invalid);
			} else {
				var inputGroup = _this6.ui.getInputGroup(input);
				// if has error message, remove it
				_this6.ui.removeErrorNode(inputGroup);

				if (input.form && input.form.hasAttribute('showvalid')) {
					// mark input as valid
					_this6.ui.setInputValid(inputGroup);
				}

				valid();
			}
		}).catch(function (data) {
			// Check if Data is system Exception
			if (data !== undefined && data.message !== undefined) {
				throw data;
			}

			// get input group and label
			var inputGroup = _this6.ui.getInputGroup(input);
			var label = _this6.ui.getLabel(inputGroup);

			// get error message
			var errorMessage = _this6._getErrorMessage(currentValidatorName, input, label, data);

			// set error message
			_this6.ui.setErrorMessage(inputGroup, errorMessage);
			invalid(errorMessage);
		});
	},
	_getErrorMessage: function _getErrorMessage(validatorName, input, label, data) {
		var message = '';
		if (typeof data === 'string') {
			// if validator returned string (from ajax for example), use it
			message = data;
		} else {
			if (this.lang[validatorName] === undefined) {
				throw new Error('Bunny Validation: Lang message not found for validator: ' + validatorName);
			}
			message = this.lang[validatorName];
		}

		// replace params in error message
		message = message.replace('{label}', this._getInputTitle(input, label));

		for (var paramName in data) {
			message = message.replace('{' + paramName + '}', data[paramName]);
		}
		return message;
	},
	_getInputTitle: function _getInputTitle(input, label) {
		if (label !== false) {
			return label.textContent;
		} else if (input.placeholder && input.placeholder !== '') {
			return input.placeholder;
		} else if (input.getAttribute('aria-label') && input.getAttribute('aria-label') !== '') {
			return input.getAttribute('aria-label');
		} else if (input.name && input.name !== '') {
			return input.name;
		} else {
			return '';
		}
	}
};

document.addEventListener('DOMContentLoaded', function () {
	[].forEach.call(document.forms, function (form) {
		if (form.getAttribute('validator') === 'bunny') {
			var inline = form.hasAttribute('validator-inline');
			Validation.init(form, inline);
		}
	});
});



ValidationConfig.classInputGroupError = 'has-error';

Validation.lang.url = 'Url invalide';

Validation.validators.url = function (input) {
	return new Promise(function (valid, invalid) {
		if( input.hasAttribute('url') ) {

			var str = input.value;
			var pattern = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[A-Za-z\u00a1-\uffff0-9]-*)*[A-Za-z\u00a1-\uffff0-9]+)(?:\.(?:[A-Za-z\u00a1-\uffff0-9]-*)*[A-Za-z\u00a1-\uffff0-9]+)*(?:\.(?:[A-Za-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
			if(!pattern.test(str)) {
				invalid();
			} else {
				valid();
			}
		} else {
			valid();
		}
	});
};


// // div/node class name selector which contains one label, one input, one help text etc.
// classInputGroup: 'form-group',
// // class to be applied on input group node if it has invalid input
// classInputGroupError: 'has-error',

// // label to pick textContent from to insert field name into error message
// classLabel: 'form-control-label',

// // error message tag name
// tagNameError: 'small',
// // error message class
// classError: 'text-help',

// // query selector to search inputs within input groups to validate
// selectorInput: '[name]'

// ValidationLang 

Validation.lang.required = "{label} est requis";
Validation.lang.email = "Entrez une adresse email valide";
// email: "'{label}' should be a valid e-mail address!",
// tel: "'{label}' is not a valid telephone number!",
// maxLength: "'{label}' length must be < '{maxLength}'",
// minLength: "'{label}' length must be > '{minLength}'",
// maxFileSize: "Max file size must be < {maxFileSize}MB, uploaded {fileSize}MB",
// image: "'{label}' should be an image (JPG or PNG)",
// minImageDimensions: "'{label}' must be > {minWidth}x{minHeight}, uploaded {width}x{height}",
// maxImageDimensions: "'{label}' must be < {maxWidth}x{maxHeight}, uploaded {width}x{height}",
// requiredFromList: "Select '{label}' from list",
// confirmation: "'{label}' is not equal to '{originalLabel}'",
// minOptions: "Please select at least {minOptionsCount} options"
